// Shared geo data for marketplace onboarding + admin flows.
// Keep this list small — only the countries we actively serve. The
// onboarding form falls back to free-text for any country not listed.

export const COUNTRIES = [
  {
    code: 'AE', name: 'United Arab Emirates', dial: '+971',
    states: ['Abu Dhabi', 'Ajman', 'Dubai', 'Fujairah', 'Ras Al Khaimah', 'Sharjah', 'Umm Al Quwain'],
  },
  {
    code: 'IN', name: 'India', dial: '+91',
    states: [
      'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh', 'Goa', 'Gujarat',
      'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka', 'Kerala', 'Madhya Pradesh',
      'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab',
      'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand',
      'West Bengal', 'Andaman & Nicobar', 'Chandigarh', 'Dadra & Nagar Haveli and Daman & Diu',
      'Delhi', 'Jammu & Kashmir', 'Ladakh', 'Lakshadweep', 'Puducherry',
    ],
  },
  {
    code: 'SA', name: 'Saudi Arabia', dial: '+966',
    states: ['Riyadh', 'Makkah', 'Madinah', 'Eastern Province', 'Asir', 'Tabuk', "Ha'il", 'Northern Borders', 'Jazan', 'Najran', 'Al Bahah', 'Al Jouf', 'Qassim'],
  },
  {
    code: 'OM', name: 'Oman', dial: '+968',
    states: ['Muscat', 'Dhofar', 'Musandam', 'Al Buraimi', 'Ad Dakhiliyah', 'Al Batinah North', 'Al Batinah South', 'Ash Sharqiyah North', 'Ash Sharqiyah South', 'Adh Dhahirah', 'Al Wusta'],
  },
  {
    code: 'KW', name: 'Kuwait', dial: '+965',
    states: ['Al Asimah', 'Hawalli', 'Farwaniya', 'Ahmadi', 'Jahra', 'Mubarak Al-Kabeer'],
  },
  {
    code: 'BH', name: 'Bahrain', dial: '+973',
    states: ['Capital', 'Muharraq', 'Northern', 'Southern'],
  },
  {
    code: 'QA', name: 'Qatar', dial: '+974',
    states: ['Ad Dawhah', 'Al Rayyan', 'Al Wakrah', 'Al Khor', 'Umm Salal', 'Ash Shamal', 'Al Shahaniya', 'Al Daayen'],
  },
  {
    code: 'US', name: 'United States', dial: '+1',
    states: [
      'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia',
      'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland',
      'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada',
      'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio',
      'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee',
      'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming',
    ],
  },
  { code: 'GB', name: 'United Kingdom', dial: '+44', states: ['England', 'Scotland', 'Wales', 'Northern Ireland'] },
  { code: 'CA', name: 'Canada', dial: '+1', states: ['Alberta', 'British Columbia', 'Manitoba', 'New Brunswick', 'Newfoundland and Labrador', 'Nova Scotia', 'Ontario', 'Prince Edward Island', 'Quebec', 'Saskatchewan', 'Northwest Territories', 'Nunavut', 'Yukon'] },
  { code: 'AU', name: 'Australia', dial: '+61', states: ['New South Wales', 'Victoria', 'Queensland', 'Western Australia', 'South Australia', 'Tasmania', 'Australian Capital Territory', 'Northern Territory'] },
  { code: 'PK', name: 'Pakistan', dial: '+92', states: ['Punjab', 'Sindh', 'Khyber Pakhtunkhwa', 'Balochistan', 'Gilgit-Baltistan', 'Azad Kashmir', 'Islamabad Capital Territory'] },
  { code: 'BD', name: 'Bangladesh', dial: '+880', states: ['Dhaka', 'Chittagong', 'Khulna', 'Rajshahi', 'Sylhet', 'Barisal', 'Rangpur', 'Mymensingh'] },
  { code: 'EG', name: 'Egypt', dial: '+20', states: ['Cairo', 'Alexandria', 'Giza', 'Qalyubia', 'Port Said', 'Suez', 'Sharqia', 'Dakahlia', 'Beheira', 'Minya', 'Asyut', 'Sohag', 'Qena', 'Luxor', 'Aswan'] },
  // Generic fallback — when the vendor's country isn't in the list,
  // they switch to "Other" which shows free-text inputs everywhere.
  { code: 'OTHER', name: 'Other', dial: '', states: [] },
];

export const countryByCode = (code) => COUNTRIES.find((c) => c.code === code) || COUNTRIES[0];

// Look up states by either country code (e.g. "AE") or human name
// (e.g. "United Arab Emirates"). Returns [] when not found so the UI
// gracefully falls back to a free-text input.
export const statesForCountry = (countryOrCode) => {
  if (!countryOrCode) return [];
  const c = COUNTRIES.find(
    (x) => x.code === countryOrCode || x.name === countryOrCode
  );
  return c?.states || [];
};

export const dialCodes = COUNTRIES
  .filter((c) => c.dial)
  .map((c) => ({ code: c.code, name: c.name, dial: c.dial }));
